import {Component, Input} from '@angular/core';
import {SlideType} from './slide-type';

@Component({
  selector: 'app-slide',
  templateUrl: './slide.component.html',
  styleUrls: ['./slide.component.scss']
})
export class SlideComponent {
  @Input() open = false;
  @Input() callToAction = 'Klik hier om te openen';
  @Input() type: SlideType = 'none';
  @Input() padding = true;
}
